module.exports = __webpack_public_path__ + "img/none.75aec215.png";